import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

export const GA_MEASUREMENT_ID = "G-1H305C6BDC";

const GoogleAnalyticsTracker: React.FC = () => {
  const location = useLocation();
  const isFirstRender = useRef(true);

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }

    if (typeof window.gtag === "function") {
      const timer = setTimeout(() => {
        const pagePath = location.pathname + location.search;
        window.gtag?.("event", "page_view", {
          page_title: document.title,
          page_location: window.location.href,
          page_path: pagePath,
          send_to: GA_MEASUREMENT_ID,
        });
      }, 100);

      return () => clearTimeout(timer);
    }
  }, [location]);

  return null;
};

export default GoogleAnalyticsTracker;
